/*
 * Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, OnInit } from "@angular/core";

@Component({
    selector: "bci-content",
    templateUrl: "./bci-content.component.html",
    styleUrls: ["./bci-content.component.scss"],
    standalone: false
})
export class BciContentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
